import React, { useEffect, useRef, useState } from 'react';
import { TextFieldFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import * as authActions from 'app/auth/store/actions';
import { useDispatch, useSelector } from 'react-redux';
import jwtService from 'app/services/jwtService/jwtService';
import ControlService from 'app/services/ControlService/ControlService';
import axios from 'axios';
import qs from 'qs';
import {
    Card, Grid, MenuItem, Paper, CardContent, Typography, Tabs, Tab, Button, InputAdornment,
    Icon
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import * as Actions from 'app/store/actions';
import { setUserData } from '../../../auth/store/actions/user.actions';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

const useStyles = makeStyles(theme => ({
    root: {
        background: 'linear-gradient(to right, ' + theme.palette.primary.dark + ' 0%, ' + darken(theme.palette.primary.dark, 0.5) + ' 100%)',
        color: theme.palette.primary.contrastText
    },
    dialogPaper: {

        width: '400px'
    }
}));

function JWTLoginTab(props) {
    const dispatch = useDispatch();
    const login = useSelector(({ auth }) => auth.login);
    const classes = useStyles();
    const dispatchMsg = useDispatch();
    const [isFormValid, setIsFormValid] = useState(false);
    const formRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [openPerfil, setOpenPerfil] = useState(false);
    const [email, handleEmail] = useState();
    const [empresas, handleEmpresas] = useState([]);
    const [empresaId, handleEmpresaId] = useState();
    const [perfiles, handlePerfiles] = useState([]);
    const [perfilId, handlePerfilId] = useState();


    function message(type = "null", message = "") {
        dispatchMsg(
            Actions.showMessage({
                message: message,
                autoHideDuration: 6000, //ms
                anchorOrigin: {
                    vertical: "top", //top bottom
                    horizontal: "center" //left center right
                },
                variant: type //success error info warning null
            })
        );
    }

    useEffect(() => {
        if (login.error && (login.error.email || login.error.password)) {
            formRef.current.updateInputsWithError({
                ...login.error
            });
            disableButton();
        }
    }, [login.error]);

    function disableButton() {
        setIsFormValid(false);
    }

    function enableButton() {
        setIsFormValid(true);
    }

    async function handleCancelClose() {
        setOpen(false);
        setOpenPerfil(false);
    }

    // Intenta entrar a la empresa elegida. Si el usuario tiene más de un
    // perfil ahí, el backend no loguea todavía: pide elegir perfil primero
    // (para que la firma y las restricciones correspondan al perfil correcto).
    function ingresarAEmpresa(emailValue, companyId, perfil) {
        dispatch(authActions.submitCompany(emailValue, companyId, perfil)).then((result) => {
            // Paso 2 rechazado (p. ej. el token temporal venció): el error llega como
            // texto y el formulario no lo muestra, así que se avisa y se cierran los diálogos.
            if (result && result.type === authActions.LOGIN_ERROR && typeof result.payload === 'string') {
                setOpen(false);
                setOpenPerfil(false);
                message('error', result.payload);
                return;
            }
            if (result && result.requiresProfile) {
                setOpen(false);
                handlePerfiles(result.perfiles);
                setOpenPerfil(true);
            }
        });
    }

    function handleSubmitLogin() {
        ingresarAEmpresa(email, empresaId);
    }

    function handleSubmitPerfil() {
        setOpenPerfil(false);
        ingresarAEmpresa(email, empresaId, perfilId);
    }

    function handleSubmit(model) {
        jwtService.signInWithEmailAndPassword(model.email, model.password)
            .then((response) => {
                const empresasUsuario = response.data.empresas || [];
                handleEmail(response.data.email)
                if (empresasUsuario.length > 1) {
                    handleEmpresas(empresasUsuario)
                    setOpen(true);
                } else if (empresasUsuario.length === 1) {
                    handleEmpresaId(empresasUsuario[0].id);
                    ingresarAEmpresa(response.data.email, empresasUsuario[0].id);
                } else {
                    return dispatch({
                        type: LOGIN_ERROR,
                        payload: { email: 'El usuario no tiene empresas asignadas' }
                    });
                }

            }).catch(error => {
                return dispatch({
                    type: LOGIN_ERROR,
                    payload: error
                });
            });
    }

    return (
        <div className="w-full">
            <Formsy
                onValidSubmit={handleSubmit}
                onValid={enableButton}
                onInvalid={disableButton}
                ref={formRef}
                className="flex flex-col justify-center w-full"
            >
                <TextFieldFormsy
                    className="mb-16"
                    type="text"
                    name="email"
                    label='Usuario'
                    id="email"
                    // validations={{
                    //     minLength: 4
                    // }}
                    // validationErrors={{
                    //     minLength: 'Min character length is 4'
                    // }}
                    onKeyPress={window.clearInterval()}
                    InputProps={{
                        endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">email</Icon></InputAdornment>
                    }}
                    variant="outlined"
                    required
                />

                <TextFieldFormsy
                    className="mb-16"
                    type="password"
                    name="password"
                    label="Contraseña"
                    id="password"
                    // validations={{
                    //     minLength: 4
                    // }}
                    // validationErrors={{
                    //     minLength: 'Min character length is 4'
                    // }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">vpn_key</Icon></InputAdornment>
                    }}
                    variant="outlined"
                    required
                />

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="w-full mx-auto mt-16 normal-case"
                    aria-label="LOG IN"
                    disabled={!isFormValid}
                    value="legacy"
                >
                    Iniciar Sesión
                </Button>

            </Formsy>

            <Formsy className="flex flex-col justify-center w-full">
                <Dialog maxWidth="md" open={open} classes={{ paper: classes.dialogPaper }} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Seleccione la Empresa</DialogTitle>
                    <DialogContent>
                        <Grid item xs={12} md={12} className="alignRight">
                            <SelectFormsy
                                className="mb-16 fullWidthSelect"
                                name="empresa"
                                value=""
                                onChange={e => handleEmpresaId(e.target.value)}
                                validationError="Seleccione una empresa"
                                required
                                fullWidth>
                                {empresas.map(item =>
                                    <MenuItem key={item.id} value={item.id}>{item.razon_social}</MenuItem>
                                )}
                            </SelectFormsy>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelClose} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleSubmitLogin} color="primary">
                            Continuar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Formsy>

            <Formsy className="flex flex-col justify-center w-full">
                <Dialog maxWidth="md" open={openPerfil} classes={{ paper: classes.dialogPaper }} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Seleccione el Perfil</DialogTitle>
                    <DialogContent>
                        <Grid item xs={12} md={12} className="alignRight">
                            <SelectFormsy
                                className="mb-16 fullWidthSelect"
                                name="perfil"
                                value=""
                                onChange={e => handlePerfilId(e.target.value)}
                                validationError="Seleccione un perfil"
                                required
                                fullWidth>
                                {perfiles.map(item =>
                                    <MenuItem key={item.profile_slug} value={item.profile_slug}>{item.profile_name}</MenuItem>
                                )}
                            </SelectFormsy>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelClose} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleSubmitPerfil} color="primary">
                            Continuar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Formsy>
        </div>
    );
}

export default JWTLoginTab;
